import React from "react";

import * as styles from "./styles";

export type ColorIconProps = {
  element: React.ReactElement;
  backgroundColor?: string;
  fillColor?: string;
};

export function ColorIcon({
  element: Icon,
  backgroundColor = "gray",
  fillColor = "black",
}: ColorIconProps) {
  return (
    <span
      className={styles.background}
      data-testid="icon-background"
      style={
        {
          "--background": backgroundColor,
          "--fill": fillColor,
        } as React.CSSProperties
      }
    >
      {React.cloneElement(Icon, {
        className: styles.icon,
        "aria-hidden": "true",
        "data-testid": "icon",
      })}
    </span>
  );
}
